export default __webpack_public_path__ + "resources/icons/d220-a70c.webp";